import { Brick, registerBrick, Transaction} from 'olympe';
import BCP from '../../../common/section_bcp/DM_BCP';
import { executeLambda } from '@olympeio/core';

export default class BulkCreateBcpRequest extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array<Object>} bcpRequestData
     * @param {ListDef} errorLog
     * @param {*} bCPWorkflowInitial
     * @param {Map} originalExcelData
     * @param {function()} forwardEvent
     * @param {Array<Object>} setRequestCreationReport
     * @param {Array<Object>} setErrorReport
     */
    async update($, [bcpRequestData, errorLog, bCPWorkflowInitial, originalExcelData], [forwardEvent, setRequestCreationReport, setErrorReport]) {
        const errorLogs = errorLog || [];
        const createdRequestLog = [];

        async function workFlowInit(workflowObject) {
            try {
                const bodyResult = await executeLambda($, bCPWorkflowInitial, [workflowObject]);
            } catch (error) {
                throw new Error(`Workflow execution error: ${error.message}`);
            }

        }

        // get Original data from originalExcelData Map  with  [PlantID+MaterialID] as a key
        const getOriginalRecord = (item) => {
            return originalExcelData.get(`${item["Plant ID"]}${item["Material ID"]}`);
        }

        for (const input of bcpRequestData) {
            try {
                const t = new Transaction();
                const newBCPRequest = BCP.create(t);
                const bcpRequestProps = new Map();
                bcpRequestProps.set(BCP.businessPartnerProp, input["PS/BP email"]);
                bcpRequestProps.set(BCP.procurementManagerProp, input["Buyer Email"]);
                bcpRequestProps.set(BCP.remarkProp, input["Remark"]);
                bcpRequestProps.set(BCP.materialIdProp, input["Material ID"]);
                bcpRequestProps.set(BCP.materialDescriptionProp, input["Material Description"]);
                bcpRequestProps.set(BCP.plantIdProp, input["Plant ID"]);
                bcpRequestProps.set(BCP.plantDescriptionProp, input["Plant Description"]);
                bcpRequestProps.set(BCP.requestorProp, input["Requestor Email"]);
                bcpRequestProps.set(BCP.requestDateProp, new Date());
                bcpRequestProps.set(BCP.statusProp, "0");
                bcpRequestProps.set(BCP.bCPStatusProp, input["Current BCP Status"]);
                bcpRequestProps.set(BCP.specificationProp, input["Specification"]);
                t.multiUpdate(newBCPRequest, bcpRequestProps);
                const result = await t.execute();
                try {
                    // Trigger Workflow Initialisation for successfully created BCP request
                    await workFlowInit(...result.getCreatedObjects());
                } catch (workflowError) {
                    errorLogs.push({  ...getOriginalRecord(input), 'Reason': workflowError.message, 'Step': 'Initialisation of the BCP workflow' });
                }
                createdRequestLog.push(...result.getCreatedObjects());

            } catch (error) {
                console.error("Transaction execution error:", error);
                errorLogs.push({ ...getOriginalRecord(input), 'Reason': error, 'Step': 'Creation of the BCP request' });
            }
        }
        setRequestCreationReport(createdRequestLog);
        setErrorReport(errorLogs);
        forwardEvent();


    }
}

registerBrick('0190ba8330948992738e', BulkCreateBcpRequest);
